import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
import PointContainer from "@/views/data-manage/test-paper/components/PointContainer.vue";
import QuestionContent from "@/views/data-manage/test-paper/components/QuestionContent.vue";
import SelectPaperBox from "./SelectPaperBox.vue";
import { getExamDetail } from "@/api/exam";
import { fetchPaperDetail } from "@/api/test-paper";
import { AppModule } from "@/store/modules/app";
const formatQuestionType = (e) => {
    switch (e) {
        case 0:
            return "单选";
        case 1:
            return "多选";
        case 2:
            return "问答";
        case 3:
            return "判断";
        case 4:
            return "填空";
        // case 5:
        //   return "不定项选择题";
        case 6:
            return "材料题";
        default:
            return "";
    }
};
const isNull = e => "" === e || new RegExp("^[ ]+$").test(e);
let ChoosePapers = class ChoosePapers extends Vue {
    constructor() {
        super(...arguments);
        this.pointArr = [];
        this.showTestPaperBox = false;
        this.questions = [];
        this.hasUser = false;
        this.quesLists = [];
        this.paperDetail = {};
        this.questionNum = '';
        this.btnLock = false;
        this.passConditionRadio = 0;
        this.passGrade = '';
    }
    get isDisabled() {
        // return Boolean(!this.paperDetail.totalScore || this.hasUser)
        return Boolean(!this.paperDetail.totalScore);
    }
    get popoverContent() {
        // return this.paperDetail.totalScore ? "已有学员参加考试，不支持更改设置" : "请先选择试卷"
        return "请先选择试卷";
    }
    get isSidebarExpanded() {
        return AppModule.sidebar.opened;
    }
    created() {
        this.loadExamInfo(this.examInfo);
        this.$bus.$on("update-question-list", e => {
            this.getQuestionListOfExam();
        });
    }
    async loadExamInfo(examinfo) {
        if (examinfo) {
            this.hasUser = examinfo.name;
            this.passConditionRadio = examinfo.coursePassScore === -1 ? 0 : 1;
            this.passGrade = examinfo.coursePassScore === -1 ? '' : examinfo.coursePassScore;
            if (examinfo.paperId) {
                this.getQuestionListOfExam(examinfo.paperId);
            }
        }
        if (!this.examId)
            return;
        this.$emit("loading", true);
        try {
            const res = await getExamDetail(this.examId);
            const data = res.data.data;
            this.hasUser = data.participateCount > 0;
            this.$emit("update-exam-info", {
                hasUser: data.participateCount > 0
            });
            if (!this.paperId && data.paperId) {
                this.$emit("update-exam-info", {
                    paperId: data.paperId
                });
            }
            this.passConditionRadio = data.coursePassScore === -1 ? 0 : 1;
            this.passGrade = data.coursePassScore === -1 ? '' : data.coursePassScore;
            this.getQuestionListOfExam();
        }
        catch (_) { }
        finally {
            this.$emit('loading', false);
        }
    }
    async getQuestionListOfExam(paperId) {
        const id = paperId || this.paperId;
        if (!id)
            return false;
        this.$emit("loading", true);
        try {
            const res = await fetchPaperDetail(id);
            const data = res.data.data;
            this.paperDetail = data;
            this.questionNum = data.question_random ? `${data.ran_question_num}/${data.total_question}` : data.totalQuestion;
            const questionList = this.handleQuestions(data.questionList);
            this.questions = questionList;
            this.changePointArr();
            return true;
        }
        catch (_) {
            return false;
        }
        finally {
            this.$emit("loading", false);
        }
    }
    last() {
        this.$emit("go-page-one");
    }
    async confirmTestPaper(paperId) {
        if (paperId !== this.paperId) {
            const isValid = await this.getQuestionListOfExam(paperId);
            isValid && this.$emit("update-exam-info", {
                paperId: paperId
            }, 2);
        }
        this.cancel();
    }
    next() {
        if (this.paperId) {
            if (isNull(this.passGrade) && this.passConditionRadio === 1) {
                return this.$message.warning("请输入考试通过分数");
            }
            if (this.passGrade > this.paperDetail.totalScore && this.passConditionRadio === 1) {
                return this.$message.warning("通过分数需小于等于试卷总分");
            }
            this.btnLock = true;
            this.$emit("update-exam-info", {
                paperId: this.paperDetail.id,
                coursePassScore: this.passConditionRadio === 0 ? -1 : Number(this.passGrade)
            }, 2);
            this.$emit("go-page-three");
            this.btnLock = false;
        }
    }
    handleQuestions(questionList) {
        return questionList.map(ques => {
            if (ques.type == 6 && ques.subQuestionList) {
                ques.subQuestionList = this.handleQuestions(ques.subQuestionList);
            }
            let score = ques.score || 2;
            if (ques.type == 4) {
                ques.everyBlankScore = ques.everyBlankScore || 2;
                score = Number(ques.everyBlankScore) * ques.optionList.length;
            }
            else if (ques.type == 6) {
                score = 0;
                ques.subQuestionList && ques.subQuestionList.forEach((q) => {
                    score += q.score;
                });
            }
            return {
                ...ques,
                typeStr: formatQuestionType(ques.type),
                score: score,
            };
        });
    }
    changePointArr() {
        const questionTypeList = [
            {
                questionTypeText: "单选",
                type: 0,
                num: 0,
                pointStatusArr: []
            },
            {
                questionTypeText: "多选",
                type: 1,
                num: 0,
                pointStatusArr: []
            },
            {
                questionTypeText: "判断",
                type: 3,
                num: 0,
                pointStatusArr: []
            },
            {
                questionTypeText: "填空",
                type: 4,
                num: 0,
                pointStatusArr: []
            },
            {
                questionTypeText: "问答",
                type: 2,
                num: 0,
                pointStatusArr: []
            },
            // {
            //   questionTypeText: "不定项选择",
            //   type: 5,
            //   num: 0,
            //   pointStatusArr: []
            // },
            {
                questionTypeText: "材料",
                type: 6,
                num: 0,
                pointStatusArr: []
            }
        ];
        this.questions.forEach(ques => {
            const type = questionTypeList.find((item) => item.type === ques.type);
            type.num++;
            type.pointStatusArr.push({
                type: ques.type,
                answer: ques.correct_answer,
                id: ques.id,
                score: ques.score,
                everyBlankScore: ques.type === 4 ? ques.everyBlankScore : ques.score
            });
        });
        this.pointArr = questionTypeList;
        this.$forceUpdate();
    }
    cancel() {
        this.showTestPaperBox = false;
    }
    newTestPaper() {
        window.open("/#/data-manager/test-paper/edit?step=1", "_blank");
    }
    chooseTestPaper() {
        // if (!this.hasUser) {
        //   this.showTestPaperBox = true
        // }
        this.showTestPaperBox = true;
    }
    handleGrade() {
        this.passConditionRadio = 1;
    }
    handlePassGradeInput(evt, total) {
        let value = evt.target.value;
        var match = value.toString().match(/^\d+(?:\.\d{0,1})?/);
        value = match ? match[0] : value;
        if (isNaN(Number(value)))
            value = '';
        if (total) {
            value = value > total ? total : value;
        }
        this.passGrade = value < 0 ? '' : value;
    }
};
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], ChoosePapers.prototype, "examId", void 0);
tslib_1.__decorate([
    Prop({ type: Object })
], ChoosePapers.prototype, "examInfo", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '' })
], ChoosePapers.prototype, "paperId", void 0);
ChoosePapers = tslib_1.__decorate([
    Component({
        name: 'ChoosePapers',
        components: {
            PointContainer,
            SelectPaperBox,
            QuestionContent,
        },
    })
], ChoosePapers);
export default ChoosePapers;
